"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewExpectedStudentFileData = exports.ExpectedStudentFile = exports.ExpectedStudentFileData = void 0;
var http_client_1 = require("./http_client");
var utils_1 = require("./utils");
var ExpectedStudentFileData = /** @class */ (function () {
    function ExpectedStudentFileData(_a) {
        var pk = _a.pk, project = _a.project, pattern = _a.pattern, min_num_matches = _a.min_num_matches, max_num_matches = _a.max_num_matches, last_modified = _a.last_modified;
        this.pk = pk;
        this.project = project;
        this.pattern = pattern;
        this.min_num_matches = min_num_matches;
        this.max_num_matches = max_num_matches;
        this.last_modified = last_modified;
    }
    return ExpectedStudentFileData;
}());
exports.ExpectedStudentFileData = ExpectedStudentFileData;
var ExpectedStudentFile = /** @class */ (function (_super) {
    __extends(ExpectedStudentFile, _super);
    function ExpectedStudentFile() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExpectedStudentFile.subscribe = function (observer) {
        ExpectedStudentFile._subscribers.add(observer);
    };
    ExpectedStudentFile.unsubscribe = function (observer) {
        ExpectedStudentFile._subscribers.delete(observer);
    };
    ExpectedStudentFile.get_all_from_project = function (project_pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/projects/" + project_pk + "/expected_student_files/")];
                    case 1:
                        response = _a.sent();
                        result = response.data.map(function (data) { return new ExpectedStudentFile(data); });
                        result.sort(function (first, second) { return first.pattern.localeCompare(second.pattern); });
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ExpectedStudentFile.get_by_pk = function (expected_student_file_pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/expected_student_files/" + expected_student_file_pk + "/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new ExpectedStudentFile(response.data)];
                }
            });
        });
    };
    ExpectedStudentFile.create = function (project_pk, data) {
        return __awaiter(this, void 0, void 0, function () {
            var response, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().post("/projects/" + project_pk + "/expected_student_files/", data)];
                    case 1:
                        response = _a.sent();
                        result = new ExpectedStudentFile(response.data);
                        ExpectedStudentFile.notify_expected_student_file_created(result);
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ExpectedStudentFile.notify_expected_student_file_created = function (expected_student_file) {
        var e_1, _a;
        try {
            for (var _b = __values(ExpectedStudentFile._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_expected_student_file_created(expected_student_file);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    ExpectedStudentFile.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().patch("/expected_student_files/" + this.pk + "/", utils_1.filter_keys(this, ExpectedStudentFile.EDITABLE_FIELDS))];
                    case 1:
                        response = _a.sent();
                        utils_1.safe_assign(this, response.data);
                        ExpectedStudentFile.notify_expected_student_file_changed(this);
                        return [2 /*return*/];
                }
            });
        });
    };
    ExpectedStudentFile.prototype.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            var last_modified, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        last_modified = this.last_modified;
                        return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/expected_student_files/" + this.pk + "/")];
                    case 1:
                        response = _a.sent();
                        utils_1.safe_assign(this, response.data);
                        if (last_modified !== this.last_modified) {
                            ExpectedStudentFile.notify_expected_student_file_changed(this);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ExpectedStudentFile.notify_expected_student_file_changed = function (expected_student_file) {
        var e_2, _a;
        try {
            for (var _b = __values(ExpectedStudentFile._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_expected_student_file_changed(expected_student_file);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    ExpectedStudentFile.prototype.delete = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().delete("/expected_student_files/" + this.pk + "/")];
                    case 1:
                        _a.sent();
                        ExpectedStudentFile.notify_expected_student_file_deleted(this);
                        return [2 /*return*/];
                }
            });
        });
    };
    ExpectedStudentFile.notify_expected_student_file_deleted = function (expected_student_file) {
        var e_3, _a;
        try {
            for (var _b = __values(ExpectedStudentFile._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_expected_student_file_deleted(expected_student_file);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    ExpectedStudentFile._subscribers = new Set();
    ExpectedStudentFile.EDITABLE_FIELDS = [
        'pattern',
        'min_num_matches',
        'max_num_matches'
    ];
    return ExpectedStudentFile;
}(ExpectedStudentFileData));
exports.ExpectedStudentFile = ExpectedStudentFile;
var NewExpectedStudentFileData = /** @class */ (function () {
    function NewExpectedStudentFileData(_a) {
        var pattern = _a.pattern, min_num_matches = _a.min_num_matches, max_num_matches = _a.max_num_matches;
        this.pattern = pattern;
        this.min_num_matches = min_num_matches;
        this.max_num_matches = max_num_matches;
    }
    return NewExpectedStudentFileData;
}());
exports.NewExpectedStudentFileData = NewExpectedStudentFileData;
//# sourceMappingURL=expected_student_file.js.map